<template>
  <div v-if="!loading">
    <div v-if="route.matched.length === 3">
      <Loader v-if="loadingContent" />
      <div v-else>
        <Transition>
          <Modal v-if="showModal" @closeModal="closeModal">
            <template #body>
              <div class="flex items-center container-cart justify-center full-height">
                <div>
                  <!-- SUCCESS -->
                  <div v-if="successModal" class="mb5 col-12 success-checkmark">
                    <div class="check-icon">
                      <span class="icon-line greener-bg line-tip"></span>
                      <span class="icon-line greener-bg line-long"></span>
                      <div class="icon-circle"></div>
                      <div class="icon-fix"></div>
                    </div>
                  </div>
                  <div v-else class="mb5 center col-12">
                    <i
                      style="font-size: 88px"
                      class="icon red line-height-2 icon-not-check-icon"
                    ></i>
                  </div>
                  <div class="h2 center" :class="successModal ? 'green' : 'red'">
                    <h2 class="h2n">{{ modalMessage }}</h2>
                  </div>
                  <div class="mt1 center my2">
                    <Button
                      text="Fermer"
                      class="col-12"
                      btn-color="red"
                      :action="closeModal"
                    />
                  </div>
                </div>
              </div>
            </template>
          </Modal>
        </Transition>
        <div v-for="(participant,index) in participants" :key="participant.uuid" class="flex flex-wrap m0 p0" :class="{'mt2': index != 0}">
          <ScheduledParticipant :participant="participant" :first-participant="index===0" />
        </div>
        <p v-if="!Object.keys(participants).length" class="h5n bold center warning m0">
          Vous n'avez pas des réservations en cours.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, inject, provide, ref, reactive } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import Loader from '@/components/common/Loader';
import Modal from '@/components/blocks/Modal';
import Button from '@/components/elements/Button';
import ScheduledParticipant from '@/components/reservations/ScheduledParticipant';

import { cancelReservation, getScheduledReservations } from '@/mixins/requests';
import { isInImpersonateModeNotification } from '@/mixins/utils';

export default {
  components: { Loader, Modal, Button, ScheduledParticipant },
  setup () {
    const route = useRoute();
    const store = useStore();

    const showModal = ref(false);
    const successModal = ref(true);
    const modalMessage = ref('');

    const workspace = computed(() => store.state.siteInfo.workspace);
    const loading = computed(() => store.state.loading);
    const loadingContent = computed(() => store.state.loadingContent);

    const participants = inject('participants');

    /* Club Pass */
    const showClubReservationModal = inject('showClubReservationModal');

    const closeModal = () => {
      showModal.value = !showModal.value;
    };

    const cancel = async (uuid, contractNumber, reservation) => {
      if (isInImpersonateModeNotification()) {
        return;
      }

      if (reservation.clubSessionReservation) {
        store.commit('setSession', { ...reservation, numeroContrat: reservation.contractNumber, updateInStore: true });
        showClubReservationModal.value = true;
        return;
      }

      store.commit('setLoading', true);
      const data = {
        workspace: workspace.value,
        sessionCode: reservation.code,
        numeroContrat: contractNumber,
        user: uuid,
        sessionName: reservation.type,
        startTimestamp: reservation.startTimestamp,
        endTimestamp: reservation.endTimestamp
      };

      modalMessage.value = 'Une erreur s’est produite lors de l’annulation de votre réservation';
      successModal.value = false;

      await cancelReservation(data)
        .then(res => {
          if (res.success) {
            modalMessage.value = `Annulation réussie.${reservation.isSingleSession ? ' Pour reprogrammer votre séance, veuillez contacter le centre' : ''}`;
            successModal.value = true;
          }
        })
        .catch(err => {
          console.log('cancelReservation error: ', err);
        })
        .finally(async () => {
          await getScheduledReservations({ workspace: workspace.value })
            .then(res => {
              participants.value = res;
            })
            .catch(err => {
              console.log('err: ', err);
              participants.value = [];
            })
            .finally(() => {
              store.commit('setLoading', false);
            });
          showModal.value = true;
        });
    };

    provide('cancel', cancel);

    return {
      store,
      route,
      loading,
      loadingContent,
      participants,
      showModal,
      modalMessage,
      successModal,
      cancel,
      closeModal
    };
  }
};
</script>

<style lang="scss" scoped>
.action:hover .breadcrumb-arrow {
  color: white;
}

.border-blue {
  border: 1px solid #00a6c6;
  color: #00a6c6;
}

.no-border-top {
  border-top: 0;
}
</style>
